import styled from 'styled-components';

export const StyledMenuGroupHeader = styled.h2`
    margin: 25px;
    color: ${({ theme }) => theme.palette.gray[600]};
`;
